import { URI_FINANCIAL_ACCOUNT } from '@/config/config';

export default async ({ rootState, commit }) => {
  const token = rootState['DATA-ACCESS'].tokenAuth;
  const opts = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  };

  const response = await fetch(`${URI_FINANCIAL_ACCOUNT}labels`, opts);
  const jsonResult = await response.json();
  if (response.status >= 400) {
    throw new Error(response.message);
  }
  if (jsonResult.error) {
    return Promise.reject(jsonResult.error);
  }
  commit('setLabels', jsonResult);

  return jsonResult.data;
};
